import { useState, useCallback, useEffect } from 'react';

const AUDIO_ENABLED_KEY = 'chatbot_audio_enabled';

interface UseAudioSettingsReturn {
  isAudioEnabled: boolean;
  toggleAudio: () => void;
  setAudioEnabled: (enabled: boolean) => void;
}

/**
 * Hook để quản lý trạng thái bật/tắt âm thanh chatbot
 * Lưu trạng thái vào localStorage để persist across sessions
 */
export const useAudioSettings = (): UseAudioSettingsReturn => {
  const [isAudioEnabled, setIsAudioEnabled] = useState<boolean>(() => {
    // Initialize from localStorage, default to true (enabled)
    const stored = localStorage.getItem(AUDIO_ENABLED_KEY);
    return stored === null ? true : stored === 'true';
  });

  // Sync to localStorage when state changes
  useEffect(() => {
    localStorage.setItem(AUDIO_ENABLED_KEY, String(isAudioEnabled));
  }, [isAudioEnabled]);

  const toggleAudio = useCallback(() => {
    setIsAudioEnabled(prev => !prev);
  }, []);

  const setAudioEnabled = useCallback((enabled: boolean) => {
    setIsAudioEnabled(enabled);
  }, []);

  return {
    isAudioEnabled,
    toggleAudio,
    setAudioEnabled,
  };
};

export default useAudioSettings;
